import {onFind} from "@elements/init-modules-in-scope";
import {on, findIn, closest} from "@elements/dom-utils";

export function init() {
    onFind(".js-collect-formdata", function(button) {

        on("click", function(){
            let form = closest('form', button);
            let target = button.getAttribute('data-bs-target');
            let modal = document.querySelector(target);
            let formInModal = findIn('form', modal);

            //get all the form data and add inputs with value to modal
            let formData = new FormData(form);
            for (var pair of formData.entries()) {
                let input = document.createElement('input');
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', pair[0]);
                input.setAttribute('value', pair[1]);
                formInModal.appendChild(input);
            }
        }, button)
    })
}
